import { Component, OnInit } from '@angular/core';

import { FavoritesService } from './products/favorites.service';
import { ConfigurationService } from './configuration.service';
import { Configuration } from './configuration';
import {MatDialog} from '@angular/material';
import * as Cookies from 'js-cookie';
import { LicenseModalComponent } from './home-page/license-modal/license-modal.component';

import { ControlsService } from './controls.service';
import { Observable } from 'rxjs/Observable';
import { map, switchMap, publish, tap, take, filter } from 'rxjs/operators';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  title = 'app';
  loginAttempted: boolean = false;

  constructor(
    private favoritesService:FavoritesService,
    private configurationService:ConfigurationService,
    public dialog: MatDialog,
    private cs: ControlsService
  ) { }

  ngOnInit() {

    const licensePopupShown: boolean =  Cookies.get('license-popup-shown');
    const savedConfiguration:Configuration = Cookies.getJSON('configuration');

    if (savedConfiguration) this.configurationService.setConfiguration(savedConfiguration);

    // 1st attempt to retrieve from cache
    this.configurationService.getConfiguration(true);

    this.configurationService.getConfigurationSubject()
    .subscribe((config:Configuration)=> {

      if(config.license) {
        this.favoritesService.updateFavorites();
        this.favoritesService.updateRecentDownload();
        // Cache the configuration for 1 day
        Cookies.set('configuration', config, { expires: 1 });
      } else if(this.loginAttempted){
        this.cs.setLicenseModalControlSubject({message: 'License could not be validated', config: config});

      } else if(!licensePopupShown){
        this.cs.setLicenseModalControlSubject({message: '', config: config});

      }

    })


    this.cs.getLicenseModalControlSubject()
    .pipe(
      tap(m => console.log("message recieved", m)),
      filter(item => item.hasOwnProperty('message'))
    )
    .subscribe(data => this.openDialog(data))


  }




  openDialog(data?: any) {
    const dialogRef = this.dialog.open(LicenseModalComponent, {
      // height: '300px',
      data: data || {}
    });

    dialogRef.afterClosed().subscribe((result: any) => {

      if (result && result.haslicense=='2' && result.license) {
        this.loginAttempted = true;



        this.configurationService.setLicense({ license: result.license})
        .subscribe((config:Configuration) => {

        });


      }  else if (result && result.haslicense=='1') {
        // they have specified that they have no license key
        Cookies.set('license-popup-shown', true, { expires: 1 });
      } else {
        // need to stop the window from opening
        Cookies.set('license-popup-shown', true, { expires: 1 });
      }

    });
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts



// WEBPACK FOOTER //
// ./src/app/app.component.ts